import React from 'react';
import { StyleSheet, View } from 'react-native';
import { styles as baseStyles, FormInput, Text, theme } from '@socrait/react';

import { setupStore } from '~/store/setupStore';

import { setupStepStyles } from './setupStepStyles';

export const ClassSetupStep = () => {
  const { firstClassName, setFirstClassName, firstShortName, setFirstShortName } = setupStore();

  return (
    <View style={setupStepStyles.container}>
      <View style={setupStepStyles.headerContainer}>
        <Text style={setupStepStyles.headerText}>
          Let's set up your <Text style={setupStepStyles.headerTextPurple}>first class</Text>
        </Text>
      </View>

      <View style={setupStepStyles.contentContainer}>
        <View style={styles.speechBubbleWrapper}>
          <View style={styles.speechBubble}>
            <Text style={styles.speechBubbleText}>Choose the class where you most need an assistant</Text>
          </View>
          <View style={styles.speechBubbleArrow} />
        </View>

        <FormInput
          blurOnSubmit={true}
          label="Class Name"
          onChangeText={setFirstClassName}
          placeholderText="Enter your class name"
          required={true}
          telemetryLabel="class-setup-class-name-input"
          value={firstClassName}
          variant="mobile"
        />

        <FormInput
          blurOnSubmit={true}
          label="Class Period"
          maxLength={3}
          onChangeText={setFirstShortName}
          placeholderText="###"
          required={true}
          telemetryLabel="class-setup-class-period-input"
          value={firstShortName}
          variant="mobile"
        />

        <View style={styles.instructionsContainer}>
          <Text style={baseStyles.boldText}>Period examples:</Text>
          <Text>1, 2, 3 ...</Text>
          <Text>5A, 5B, 5C ...</Text>
          <Text>MTH, SCI, ELA ...</Text>
        </View>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  speechBubbleWrapper: {
    alignItems: 'flex-end',
    marginHorizontal: 'auto',
    marginBottom: -theme.spacing.medium,
    marginTop: theme.spacing.xxlarge,
  },
  speechBubble: {
    backgroundColor: theme.colors.navy,
    borderRadius: theme.borderRadius.medium,
    paddingVertical: theme.spacing.medium,
    paddingHorizontal: theme.spacing.large,
  },
  speechBubbleText: {
    color: theme.colors.white,
    fontSize: theme.fontSizes.small,
    textAlign: 'center',
  },
  speechBubbleArrow: {
    width: 0,
    height: 0,
    backgroundColor: 'transparent',
    borderStyle: 'solid',
    borderLeftWidth: 10,
    borderRightWidth: 10,
    borderTopWidth: 10,
    borderLeftColor: 'transparent',
    borderRightColor: 'transparent',
    borderTopColor: theme.colors.navy,
    marginRight: theme.spacing.large,
  },
  instructionsContainer: {
    gap: theme.spacing.small,
  },
});
